/** Misma referencia regional que footer / topbar Nebula (hora del sistema). */
export const VAULT_DISPLAY_LOCALE = 'es-CO';

/**
 * Fechas del backend suelen venir en UTC sin sufijo `Z`.
 * Sin normalizar, el navegador las trata como hora local y desfasa ~5 h vs el reloj del sistema.
 */
export function parseVaultApiDateTime(value: string | Date | null | undefined): Date {
  if (value instanceof Date) {
    return value;
  }
  const trimmed = String(value ?? '').trim();
  if (!trimmed) {
    return new Date(Number.NaN);
  }
  if (/[zZ]$/.test(trimmed) || /[+-]\d{2}:\d{2}$/.test(trimmed)) {
    return new Date(trimmed);
  }
  const isoLike = trimmed.includes('T')
    ? trimmed
    : trimmed.replace(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/, '$1T$2');
  if (/^\d{4}-\d{2}-\d{2}T\d/.test(isoLike)) {
    const withoutExtraFraction = isoLike.replace(/(\.\d{3})\d+/, '$1');
    return new Date(`${withoutExtraFraction}Z`);
  }
  return new Date(trimmed);
}

export function formatVaultLocalDateTime(value: string): string {
  const date = parseVaultApiDateTime(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleString(VAULT_DISPLAY_LOCALE, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export function formatVaultLocalDate(
  value: string,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = parseVaultApiDateTime(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleDateString(
    VAULT_DISPLAY_LOCALE,
    options ?? {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  );
}

export function formatVaultLocalTime(value: string): string {
  const date = parseVaultApiDateTime(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleTimeString(VAULT_DISPLAY_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}
